import React, { useEffect, useState } from "react";
import { Box, Text, Flex, Select } from "@chakra-ui/react";
import { FaRegFilePdf } from "react-icons/fa"; 
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SpinnerLoader from "components/Spinner/SpinnerLoader";
import dateTimeFormat from "jsFunctions/dateTimeFormat";
import {  BsPrinter } from "react-icons/bs";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import LedgerTable from "./ledgerTable";
import { useToasts } from "react-toast-notifications";
import { fetchAsyncGetOrganization } from "redux/organizationSlice";
import GetAddress from "components/GetAddress";
import CustomDropdown from "views/admin/vendorDetail/vendorLedger/customDateRenge";
import ClientLedgerPdf from "./clientLedgerPdf";
import { fetchAsyncGetClientLedgerOverview } from "redux/clientProjectSlice";

import { generateYearOptions } from "views/admin/default/components/filterOption";

const {yearOption,defaultSelected} = generateYearOptions();
const years = [
...yearOption,
  { label: "Custom", value: "custom" }

];
const ClientLedger = ({activeTab,projectOptions, clientDetails}) => {
  const { id } = useParams();  
  const dispatch = useDispatch();
  const [organizationData,setOrganizationData] = useState({})
  const [loading, setLoading] = useState(false); 
  const [ledgerData,setLedgerData] = useState([])
  const [totalAmount,setTotalAmount] = useState({})
  const { addToast } = useToasts();
  const [projectId,setProjectId] = useState(null);

  const [dateRenge,setDateRenge] = useState({
    startDate:'',
    endDate:''
  })

  useEffect(() => {
    if (id) {
      dispatch(fetchAsyncGetOrganization())
    }
  }, [id]); 

  const [selectedYear, setSelectedYear] = useState(defaultSelected); 
  const [startYear, endYear] = selectedYear.split('-').map(Number);
  const logoData = useSelector((state) => state.logoData);
  const organizationList = useSelector((state) => state.organizationData);
  const logoUrl = logoData?.downloadUrl || "";


  const fetchLedgerDetails = async (vendorId) => {
    if(selectedYear !== 'custom'){
      setLoading(true)
      try {
        const res = await dispatch(fetchAsyncGetClientLedgerOverview({
          id: vendorId,
          financialYear:selectedYear,
          dateRenge:dateRenge,
          projectId
          })); 
        if (res?.payload) {
          const ledgerRecords = res?.payload?.formattedResult || [];
          const total = res?.payload?.totals || {};
          setLedgerData(ledgerRecords)
          setTotalAmount(total)
          setLoading(false)
        }
        else{
          setLoading(false)
        }
      } catch (error) {
        addToast(`Error fetching client Ledger details:`, { appearance: "error" });
        setLoading(false)
      }
    }
    else{
      if(dateRenge.startDate && dateRenge.endDate){

        setLoading(true)
        try {
          const res = await dispatch(fetchAsyncGetClientLedgerOverview({
            id: vendorId,
            financialYear:selectedYear,
            dateRenge:dateRenge,
            projectId
            })); 
          if (res?.payload) {
            const ledgerRecords = res?.payload?.formattedResult || [];
            const total = res?.payload?.totals || {};
            setLedgerData(ledgerRecords)
            setTotalAmount(total)
            setLoading(false)
          }
          else{
            setLoading(false)

          }
        } catch (error) {
          addToast(`Error fetching client Ledger details:`, { appearance: "error" });
          setLoading(false)
        }
      }
    }
    
  };

  const handleApplyCustom = (date)=>{
    setDateRenge(date)
  }
  useEffect(() => {
    if (id && activeTab === 'Ledger') {
      fetchLedgerDetails(id)
    }
  }, [id,selectedYear,dateRenge,activeTab,projectId]);

  const handlePdf = () => {
    const input = document.getElementById("pdf-content");
  
    html2canvas(input, { useCORS: true, allowTaint: true,scale:3 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg",1);
      const pdf = new jsPDF();
      const imgWidth = 210; 
      const pageHeight = pdf.internal.pageSize.height;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;
      let heightLeft = imgHeight;

      let position = 0;

      pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
      heightLeft -= pageHeight;

      while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }

      let filename = `${clientDetails?.clName}_ledger.pdf`
      if(projectId){
        const prj = projectOptions.find((item)=> item.value === projectId);
        filename = `${clientDetails?.clName}_${prj?.label}_ledger.pdf`
      }
      pdf.save(filename);
    });
  };

  const handlePrint = () => {
    const printContent = document.getElementById("pdf-content");
    const newWindow = window.open("", "_blank");
    newWindow.document.write(`
      <html>
        <head>
          <title>Print</title>
          <style>
            body { font-family: Arial, sans-serif; }
            table { width: 100%; border-collapse: collapse; }
            th, td { border: 1px solid #ddd; padding: 8px; }
            th { background-color: #f2f2f2; }
          </style>
        </head>
        <body>
          ${printContent.innerHTML}
        </body>
      </html>
    `);
    newWindow.document.close();
    newWindow.print();
  };

  useEffect(()=>{
    if(organizationList && organizationList?.length){
      const data = organizationList[0];
      setOrganizationData(data)
    }
  },[organizationList])

  if (loading) {return (<SpinnerLoader/>)}

  return (
    <>
      <Box display="flex" className="mx-0  vendor_details vendor-ledger-details">
        <Box className="vendor_details_main mt-4 mx-5">
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Box display="flex">

            <Box className="ledger-year-select">

               <CustomDropdown
                years={years}
                selectedYear={selectedYear}
                setSelectedYear={setSelectedYear}
                handleApply={(date)=>handleApplyCustom(date)}
                dateRenge={dateRenge}
                />
                
            </Box>
            <Select
             className="mx-4 client-details-select-field"
             width="180px"
             value={projectId}
             onChange={(e) => setProjectId(e.target.value)}
           >
            <option value="">Select Project</option>
             {projectOptions.map((prj) => (
               <option key={prj.value} value={prj.value}>
                 {prj.label}
               </option>
             ))}
           </Select>
            </Box>
            <Box display="flex">
              <div className="vendor-ledger-icon">
                <button title="Print" className="ledger-icon" onClick={()=>handlePrint()} >
                  <BsPrinter />
                </button>
                <button title="PDF" onClick={()=>handlePdf()} className="ledger-icon">
                  <FaRegFilePdf />
                </button>
               
              </div>
            </Box>
          </Box>
          <Box height={400} className="ledger-details">
            <Box className="vendor-statement">
              <Text>
                <strong>
                  Client Statement For {clientDetails?.clName}
                </strong>
              </Text>
              <Text>
                {" "}
                From {dateTimeFormat(dateRenge?.startDate ? dateRenge?.startDate :`${startYear}-04-01`)} To {" "}
                {dateTimeFormat(dateRenge?.endDate ? dateRenge?.endDate :`${endYear}-03-31`)}
              </Text>
            </Box>
            <div className="details-container">
              <Box className="ledger-template" >
                    <Flex align="center" direction="column" className="ledger-logo">
                      <img src={logoUrl} alt="logo" />
                    </Flex>
                <Box
                  display="flex"
                  className="ledger-header"
                  justifyContent="space-between"
                >
                  <div className="header-left header-box">
                    <Text className="title">{organizationData?.name}</Text>
                    <Text className="address">
                    <GetAddress address={organizationData?.add}/>

                    </Text>
                  </div>
                  <div className="header-right header-box">
                    <Text className="title">{clientDetails?.clName}</Text>
                    <Text className="address">
                      <GetAddress address={clientDetails?.add}/>
                    </Text>
                  </div>
                </Box>
                <Box className="ledger-main">
                    <Text className="ledger-date">Date: {dateTimeFormat(dateRenge?.startDate ? dateRenge?.startDate :`${startYear}-04-01`)} to {dateTimeFormat(dateRenge?.endDate ? dateRenge?.endDate :`${endYear}-03-31`)}</Text>
                    <Box className="ledger-table">
                      <LedgerTable ledgerData={ledgerData} total={totalAmount}/>
                    </Box>                                                          
                </Box>           
              </Box>
            </div>
            <Box height={10}></Box>
            <div id="pdf-content" className="pdf-main-container">

              <ClientLedgerPdf organizationData={organizationData} logoUrl={logoUrl} dateRenge={dateRenge} startYear={startYear} endYear={endYear} ledgerData={ledgerData} total={totalAmount} clientDetails={clientDetails}/>
            </div>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default ClientLedger;
